<template>
	<!--<div>
		<v-card-text class="py-0">-->
			<v-container fluid class="pt-0">
				<v-row style="margin-top: 10px;" class="mx-0">
					<!--<v-col cols="12" class="px-0">
						<h2 v-if="upgrade" class="black--text">
							{{ $t('wkt.admin.license.upgrade-account-window.step-3.upgrade_title') }}
						</h2>
						<h2 v-else class="black--text">
							{{ $t('wkt.admin.license.upgrade-account-window.step-3.renew_title') }}
						</h2>
					</v-col>-->
					<v-col cols="12" class="pa-0 pt-2">
						<span style="font-size: 14px;" class="black--text font-weight-bold">
							{{ $t('wkt.admin.license.upgrade-account-window.step-3.subtitle') }}
						</span>
					</v-col>
					<v-col cols="12" class="px-0 mt-2 pb-0">						
						<LicenseItems 
							:company="company" 
							:licensingInfo="licensingInfo" 
							:licenseType="licenseType" 
							:licensePlan="licensePlan" 
							:planEmployees="planEmployees"
							:planStorage="planStorage"
							:planSignatures="planSignatures"
							:autorenew="selectedAutorenew"
							:renewDate="renewDate"
							:readOnly="true"
							:upgrade="upgrade" 
							@add-voucher="$emit('add-voucher', $event)" />
					</v-col>					
				</v-row>					
				<v-row class="pt-2 pb-4 d-flex justify-space-between align-start">
					<v-col v-if="upgrade && showAutorenew" cols="6" class="mt-1 pa-0 pl-6 d-flex align-center">
						<span style="font-size: 16px;">
							{{ $t('wkt.admin.license.upgrade-account-window.step-3.autorenew') }}
						</span>
						<v-switch 
							hide-details
							v-model="selectedAutorenew"
							color="#185EA9"
							class="ma-0 ml-4" 
							:upgrade="upgrade"
							@change="updateAutorenew(false, true)" />
					</v-col>
					<v-col :cols="upgrade && showAutorenew ? '6' : '12'" class="mt-1 pa-0 d-flex flex-column">
						<div class="pr-6 d-flex justify-end">
							<span style="font-size: 16px;" class="mr-2">
								{{ $t('wkt.admin.license.upgrade-account-window.step-3.gross_amount') }}
							</span>
							<span style="width: 100px; font-size: 16px; text-align: right;">{{ amount }}</span>
						</div>
						<div class="pr-6 d-flex justify-end">
							<span style="font-size: 16px; color: #A0A0A0;" class="mr-2">
								{{ $t('wkt.admin.license.upgrade-account-window.step-3.taxes') }}
							</span>
							<span style="width: 100px; font-size: 16px; color: #A0A0A0; text-align: right;">{{ taxes }}</span>
						</div>
						<div v-if="voucher" class="pr-6 d-flex justify-end">
							<span style="font-size: 16px;" class="mr-2 green--text">
								{{ $t('wkt.admin.license.upgrade-account-window.step-3.discount') }}
							</span>
							<span style="width: 100px; font-size: 16px; text-align: right;" class="green--text">{{ discount }}</span>
						</div>
						<div class="pr-6 d-flex justify-end">
							<span style="font-size: 16px;" class="mr-2 black--text font-weight-bold">
								{{ $t('wkt.admin.license.upgrade-account-window.step-3.total_amount') }}
							</span>
							<span style="width: 100px; font-size: 16px; text-align: right;" class="black--text font-weight-bold">{{ total }}</span>
						</div>
					</v-col>
				</v-row>
			</v-container>
		<!--</v-card-text>
		<v-divider></v-divider>
		<v-card-actions>
			<v-btn color="#185EA9" text @click="$emit('open-rates')" style="font-size: 0.9em; font-weight: 400;">
				<v-icon small color="#185EA9" class="mr-2">open_in_new</v-icon>
				<span class="text-decoration-underline">{{ $t('wkt.admin.license.upgrade-account-window.step-1.more_info').toUpperCase() }}</span>
			</v-btn>
			<v-spacer></v-spacer>
			<v-btn color="#185EA9" text @click="$emit('finished')" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.continue').toUpperCase() }}</v-btn>
			<v-btn text @click="$emit('close-dialog')" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
		</v-card-actions>
	</div>-->
</template>

<script>
import BaseModule from '../../../common/BaseModule.js';
import PurchaseUtils from './PurchaseUtils.js';
import LicenseItems from './LicenseItems';

  export default {
    name: 'UpgradePlanStep3',
    mixins: [BaseModule, PurchaseUtils],
	props: ['company','licensingInfo','licenseType','licensePlan','planEmployees','planStorage','planSignatures','autorenew','voucher','upgrade'],
	watch: {
		/*numEmployees: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				this.selectedEmployees = newValue;
			}
		},		
		numStorage: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				this.selectedStorage = newValue;
			}
		},
		numSignatures: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				this.selectedSignatures = newValue;
			}
		},*/
		autorenew: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				if (!this.autorenew && this.autorenew !== false) {
					this.selectedAutorenew = this.company.licensePlanAutonrenew;
					//this.$emit('autorenew-changed', this.selectedAutorenew);
					this.updateAutorenew(true, true);
				} else {
					this.selectedAutorenew = newValue;
					//this.$emit('autorenew-changed', this.selectedAutorenew);
					//this.updateAutorenew(force, false);
				}
			}
		}
	},
	components: {
		LicenseItems
	},
    data () {
		return {
			//planEmployees: 0,
			//planStorage: 0, 
			//planSignatures: 0,
			selectedAutorenew: false,
			renewDate: null,
			currentPrice: 0,
			currentTax: 0,
		}
    },
	mounted() {
		console.log(`*** this.licenseType: ${this.licenseType}`);
		console.log(`*** this.licensePlan: ${this.licensePlan}`);
		console.log(`*** UpgradePlanStep3.upgrade: ${this.upgrade}`);
		
		this.calculateAmounts();
		/*this.selectedEmployees = this.numEmployees;
		this.selectedStorage = this.numStorage;
		this.selectedSignatures = this.numSignatures;
		if (!this.autorenew && this.autorenew !== false) {
			this.selectedAutorenew = this.company.licenseAutorenew;
			this.$emit('autorenew-changed', this.selectedAutorenew);
		} else {
			this.selectedAutorenew = this.autorenew;
			//this.$emit('autorenew-changed', this.selectedAutorenew);
		}*/
	},
	computed: {
		currentPlan() {
			if (!this.company) {
				return '???';
			}

			let text = '';

			switch (this.company.licenseType) {
				case this.constants.LICENSE_TYPE_FREE: 
					text = this.$t('wkt.admin.license.type-free-description');
					break;
				case this.constants.LICENSE_TYPE_BUSINESS: 
					text = this.$t('wkt.admin.license.type-business-description');
					break;
				case this.constants.LICENSE_TYPE_CORPORATE: 
					text = this.$t('wkt.admin.license.type-corporate-description');
					break;
			}

			text += ' - ';

			switch (this.company.licensePlan) {
				case this.constants.LICENSE_PLAN_FREE: 
					text += this.$t('wkt.admin.license.plan-free-description');
					break;
				case this.constants.LICENSE_PLAN_MONTHLY:
					text += this.$t('wkt.admin.license.plan-monthly-description');
					break;
				case this.constants.LICENSE_PLAN_ANNUAL: 
					text += this.$t('wkt.admin.license.plan-annual-description');
					break;
			}

			return text;
		},
		showAutorenew() {
			let total = this.currentPrice + this.currentTax;
			
			if (this.voucher) {
				total = total * (1 - this.voucher.discountPercent);			
			}

			return total > 0;
		},
		/*dueDate() {
			if (!this.company) {
				return '';
			}

			/*const dueDate = !this.selectedAutorenew ? new Date(this.company.licensePlanExpires) : new Date();

			if (this.selectedPlan == this.constants.LICENSE_PLAN_ANNUAL) {
				dueDate = new Date(date.setMonth(date.getMonth()+12));
			} else {
				dueDate = new Date(date.setMonth(date.getMonth()+1));
			}

			let text = this.formatOnlyDate(dueDate);

			let text = this.formatOnlyDate(this.renewDate);
			
			//let text = this.formatOnlyDate(this.company.licensePlanExpires);
			
			text += ' - ';

			if (this.company.licensePlanAutonrenew) {
				text += this.$t('wkt.admin.license.plan.renew.automatic');
			} else {
				text += this.$t('wkt.admin.license.plan.renew.manual');
			}

			return text;
		},*/
		amount() {
			let amount = Math.round((this.currentPrice * 100) * (1 + Number.EPSILON)) / 100;
			return `${amount.toFixed(2)}€`;
		},
		taxes() {
			let taxes = Math.round((this.currentTax * 100) * (1 + Number.EPSILON)) / 100;
			return `${taxes.toFixed(2)}€`;
		},
		discount() {
			const discount = Math.round(this.voucher.discountPercent * 10000) / 100;
			return `-${discount}%`;
		},
		total() {
			let amount = Math.round((this.currentPrice * 100) * (1 + Number.EPSILON)) / 100;
			let taxes = Math.round((this.currentTax * 100) * (1 + Number.EPSILON)) / 100;
			let total = amount + taxes;
			
			if (this.voucher) {
				total = total * (1 - this.voucher.discountPercent);			
			}
			
			total = Math.round((total * 100) * (1 + Number.EPSILON)) / 100;

			return `${total.toFixed(2)}€`;
		}
	},
    methods: {
		calculateAmounts() {
			const licenseClass = this.licenseType === this.constants.LICENSE_TYPE_FREE ? this.constants.LICENSE_CLASS_BASE : this.constants.LICENSE_CLASS_EXTENSION;

			const additionalEmployees = this.findLicenseSKU(this.licensingInfo, this.constants.ACTIVE_EMPLOYEES, this.licenseType, this.licensePlan, licenseClass);

			let upgradePrice = this.planEmployees * additionalEmployees.price;
			let upgradeTax = upgradePrice * additionalEmployees.taxPercent;

			const baseStorage = this.findLicenseSKU(this.licensingInfo, this.constants.STORAGE_MB, this.licenseType, this.licensePlan, this.constants.LICENSE_CLASS_BASE);
			const additionalStorage = this.findLicenseSKU(this.licensingInfo, this.constants.STORAGE_MB, this.licenseType, this.licensePlan, licenseClass);

			const storageQuantity = this.planStorage - baseStorage.quantity;
			upgradePrice += baseStorage.price + storageQuantity * additionalStorage.price;
			upgradeTax += baseStorage.price * baseStorage.taxPercent + storageQuantity * additionalStorage.price * additionalStorage.taxPercent;

			this.currentPrice = upgradePrice;
			this.currentTax = upgradeTax;
			
			/*const baseSignatures = this.findStockSKU(this.licensingInfo, this.constants.SMS_SIGNATURE, this.licenseType, this.licensePlan, this.constants.LICENSE_CLASS_BASE);
			const additionalSignatures = this.findStockSKU(this.licensingInfo, this.constants.SMS_SIGNATURE, this.licenseType, this.licensePlan, this.constants.LICENSE_CLASS_EXTENSION);

			console.log(`**** baseSignatures: ${JSON.stringify(baseSignatures)}`);
			console.log(`**** additionalSignatures: ${JSON.stringify(additionalSignatures)}`);

			const signaturesQuantity = this.planSignatures - baseSignatures.quantity;
			this.currentPrice += baseSignatures.price + signaturesQuantity * additionalSignatures.price;
			this.currentTax += baseSignatures.price * baseSignatures.taxPercent + signaturesQuantity * additionalSignatures.price * additionalSignatures.taxPercent;
			
			console.log(`**** SIGNATURES`);
			console.log(`**** upgradePrice + (${baseSignatures.price} + ${signaturesQuantity} * ${additionalSignatures.price}): ${upgradePrice}`);
			console.log(`**** upgradeTax + (${baseSignatures.price} * ${signaturesQuantity.taxPercent} +  ${signaturesQuantity} * ${additionalSignatures.price} * ${additionalSignatures.taxPercent}): ${upgradeTax}`);*/
		},
		updateAutorenew(force, fireEvent) {
			if (force) {
				const date = !this.selectedAutorenew ? new Date(this.company.licensePlanExpires) : new Date();

				if (this.licensePlan == this.constants.LICENSE_PLAN_ANNUAL) {
					this.renewDate = new Date(date.setMonth(date.getMonth() + 12));
				} else {
					this.renewDate = new Date(date.setMonth(date.getMonth() + 1));
				}
			
				this.$emit('renewdate-changed', this.renewDate);
			}

			if (fireEvent) {
				this.$emit('autorenew-changed', this.selectedAutorenew);
			}
		}
	}
}
</script>